import config from "../../../shared/config/config";

import axiosAdmin from "../../../shared/utils/axiosAdmin";
import axiosAdminBlob from "../../../shared/utils/axiosAdminBlob";
import {
  LoginLogRequestDTO,
  LoginLogRespondDTO,
} from "../../../types/adminLog";
import { LogDTO, LogList } from "../../../types/log";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminLogApi {
  getLoginLog(
    logSearchOptions: LoginLogRequestDTO
  ): Promise<LoginLogRespondDTO>;
  getLoginLogExcel(logSearchOptions: LoginLogRequestDTO): Promise<any>;
  getWorkgroupLog(logSearchOptions: LogDTO): Promise<LogList>;
  getWorkgroupLogExcel(logSearchOptions: LogDTO): Promise<any>;
  getDocLog(logSearchOptions: LogDTO): Promise<LogList>;
  getDocLogExcel(logSearchOptions: LogDTO): Promise<any>;
}

class AdminLogServerApi implements AdminLogApi {
  async getLoginLog(
    logSearchOptions: LoginLogRequestDTO
  ): Promise<LoginLogRespondDTO> {
    const resp = await axiosAdmin.post<LoginLogRespondDTO>(
      `${GATEWAY_URL}/wapi/admins/logs/login`,
      logSearchOptions
    );

    return Promise.resolve(resp.data);
  }
  async getLoginLogExcel(logSearchOptions: LoginLogRequestDTO): Promise<any> {
    try {
      const resp = await axiosAdminBlob.post<LoginLogRespondDTO>(
        `${GATEWAY_URL}/wapi/admins/logs/login/excel`,
        logSearchOptions
      );
      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async getWorkgroupLog(logSearchOptions: LogDTO): Promise<LogList> {
    const resp = await axiosAdmin.post<LogList>(
      `${GATEWAY_URL}/wapi/admins/logs/new/paging`,
      logSearchOptions
    );
    return Promise.resolve(resp.data);
  }
  async getWorkgroupLogExcel(logSearchOptions: LogDTO): Promise<any> {
    try {
      const resp = await axiosAdminBlob.post<LogList>(
        `${GATEWAY_URL}/wapi/admins/logs/new/paging/excel`,
        logSearchOptions
      );
      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async getDocLog(logSearchOptions: LogDTO): Promise<LogList> {
    const resp = await axiosAdmin.post<LogList>(
      `${GATEWAY_URL}/wapi/admins/logs/new/paging`,
      logSearchOptions
    );
    return Promise.resolve(resp.data);
  }
  async getDocLogExcel(logSearchOptions: LogDTO): Promise<any> {
    try {
      const resp = await axiosAdminBlob.post<LogList>(
        `${GATEWAY_URL}/wapi/admins/logs/new/paging/excel`,
        logSearchOptions
      );
      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
}
const adminLogApi: AdminLogApi = new AdminLogServerApi();
export default adminLogApi;
